﻿import type { CallbackFunc } from '../types/utils/ajax';

export function ajaxPost(
    url: RequestInfo,
    data: any = null,
    doneFunc: CallbackFunc = null,
    failFunc: CallbackFunc = null,
    alwaysFunc: CallbackFunc = null
) {
    fetchRequest(url, data, 'POST', doneFunc, failFunc, alwaysFunc);
}

export function ajaxGet(
    url: RequestInfo,
    data: any = null,
    doneFunc: CallbackFunc,
    failFunc: CallbackFunc,
    alwaysFunc: CallbackFunc
) {
    fetchRequest(url, data, 'GET', doneFunc, failFunc, alwaysFunc);
}

export function ajaxPut(
    url: RequestInfo,
    data: any = null,
    doneFunc: CallbackFunc,
    failFunc: CallbackFunc,
    alwaysFunc: CallbackFunc
) {
    fetchRequest(url, data, 'PUT', doneFunc, failFunc, alwaysFunc);
}

export function ajaxDelete(
    url: RequestInfo,
    data: any = null,
    doneFunc: CallbackFunc,
    failFunc: CallbackFunc,
    alwaysFunc: CallbackFunc
) {
    fetchRequest(url, data, 'DELETE', doneFunc, failFunc, alwaysFunc);
}

function fetchRequest(
    url: RequestInfo,
    data: any,
    type: 'POST' | 'DELETE' | 'GET' | 'PUT',
    doneFunc: CallbackFunc,
    failFunc: CallbackFunc,
    alwaysFunc: CallbackFunc
) {
    let body: string | null = null;
    if (type === 'GET' || type === 'DELETE') {
        if (!url.toString().endsWith('?') && data) {
            url += '?';
        }

        url += jQuery.param(data);
    }
    else {
        body = JSON.stringify(data);
    }

    fetch(url, {
        method: type,
        body: body,
        headers: {
            'Content-Type': 'application/json;charset=utf-8',
            'X-Timezone': (-(new Date().getTimezoneOffset() / 60)).toString()
        }
    })
        .then(async response => {
            if (response.status !== 200) {
                const responseText = await response.text();
                await failFunc?.(responseText);
            }
            else {
                const responseJson = await response.json();
                await doneFunc?.(responseJson);
            }

            await alwaysFunc?.(response);
        })
        .catch(async error => {
            const userError = 'Серверная ошибка.';
            console.error(error);
            await failFunc?.(userError);
            await alwaysFunc?.(userError);
        });
}

window.ajaxGet = ajaxGet;
window.ajaxPost = ajaxPost;
window.ajaxDelete = ajaxDelete;
window.ajaxPut = ajaxPut;